const GenericComponent = ({ title, selectedProduct }) => (
  <div className="space-y-4">
    <h3 className="text-md font-medium text-gray-800">{title}</h3>
    <div className="bg-gray-50 p-3 rounded-lg">
      <p className="text-sm text-gray-600">
        {title} details for: <strong>{selectedProduct?.description}</strong>
      </p>
    </div>
    <div className="space-y-2">
      <div className="border border-gray-200 rounded-lg p-3">
        <p className="text-sm">
          This is a placeholder for {title} functionality.
        </p>
        <p className="text-xs text-gray-500 mt-2">
          Product Code: {selectedProduct?.code}
        </p>
      </div>
    </div>
  </div>
);
export default GenericComponent;
